import { client } from "./index";

// Suggestions to Ownezzy: owners and partners send them, the Super Admin answers
export const getSuggestions = (params) => client.get("/admin/suggestions", { params });
export const sendSuggestion = (payload) => client.post("/admin/suggestions", payload);
export const answerSuggestion = (id, payload) => client.put(`/admin/suggestions/${id}`, payload);
// One suggestion with its full chat (opening it marks messages read), and sending a chat message
export const getSuggestion = (id) => client.get(`/admin/suggestions/${id}`);
export const sendSuggestionMessage = (id, text) => client.post(`/admin/suggestions/${id}/messages`, { text });
// Messages waiting for the viewer (badge on the Suggestions tab)
export const getUnreadSuggestions = () => client.get("/admin/suggestions/unread");
